export const CHANGETYPE_COMMAND_NEW_LINE = "split-block";
export const CHANGETYPE_COMMAND_NEW_PARAGRAPH =
  "my-custom-command-new-paragraph";
